;(() => {
	const attachBanner = el => {
		const banner = generateBanner()

		el.insertBefore(banner, el.firstElementChild)
	}

	const generateBanner = () => {
		const cssClass = 'banner-ebike'
		const node = document.createElement('div')
		node.classList.add(cssClass)
		node.classList.add('dkreset')

		node.innerHTML = `
			<a href="${mL('url')}" target="_blank" class="${cssClass}__content">
				<div class="${cssClass}__text">
					<p class="${cssClass}__title">${mL('title')}</p>
					<p class="${cssClass}__copy">${mL('copy')}</p>
				</div>
				<button type="button" class="${cssClass}__btn">${mL('scopri')}</button>
			</a>
		`
		node.querySelector('a').style.backgroundImage = "url('../images/e-bike/ebike-wide.jpg?v=2')"

		return node
	}

	const mL = string => {
		const lang = WC?.lang ? WC.lang.substring(0, 2) : 'it'

		const data = {
			url: {
				it: '/it/e-bike/',
				en: '/en/e-bike/',
				de: '/de/e-bike/',
			},
			title: {
				it: "L'ALTOPIANO IN E-BIKE",
				en: 'THE PLATEAU BY E-BIKE',
				de: 'DAS HIGHLAND VON E-BIKE',
			},
			copy: {
				it: 'Noleggio, itinerari ed escursioni guidate',
				en: 'Rental, itineraries and guided excursions',
				de: 'Vermietung, Reiserouten und geführte Ausflüge',
			},
			scopri: {
				it: 'Scopri',
				en: 'Discover',
				de: 'Entdecken',
			},
		}

		return data?.[string]?.[lang] || '???'
	}

	const el = document.querySelector('.body-page .riquadro')
	if (WC?.idMenu === 132 && !WC?.idCliente) {
		attachBanner(el)
	}
})()
